export default "__VITE_ASSET__DPi59aDQ__"